import React from "react";
import { Box, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import "./OfferDetailsFooter.css";
import { IOffer } from "../../../../Interface/scheduler/form";
import { OFFER_COMPONENT_CONSTANTS } from "../../../../constants/constant";
import { useFormContext } from "../../../../common/contexts/FormContext";

export interface OfferDetailsFooterProps {
  offerDetails: IOffer;
  offerRemoved?: boolean;
}

const OfferDetailsFooter: React.FC<OfferDetailsFooterProps> = ({
  offerDetails,
}) => {
  const shouldDisplayOffer = offerDetails;
  const { formValues } = useFormContext();

  if (!shouldDisplayOffer) {
    return null;
  }

  return (
    <Box
      className="offer-details-footer"
      sx={{
        backgroundColor: "secondary.light",
        color: "primary.dark",
        overflow: "hidden",
      }}
    >
      {formValues?.offerRemoved ? (
        <Box>
          <Typography variant="subtitle1" className="offer-title">
            {OFFER_COMPONENT_CONSTANTS.OFFER_REMOVED_TEXT}
          </Typography>
        </Box>
      ) : (
        <Box>
          <div className="offer-icon">
            <CheckCircleIcon
              sx={{
                color: "primary.dark",
              }}
              className="offer-check-icon"
            />
            <Typography variant="subtitle1" className="offer-title">
              {OFFER_COMPONENT_CONSTANTS.OFFER_ATTACHED_TEXT}
            </Typography>
          </div>
          <Typography variant="body1" sx={{ mt: 0.5 }} className="offer-code">
            {(offerDetails.couponCode || offerDetails.couponcode) && (
              <span style={{ fontWeight: 700 }}>
                {offerDetails.couponcode || offerDetails.couponCode} -{" "}
              </span>
            )}
            {offerDetails.title && (
              <span style={{ fontWeight: 700 }}>{offerDetails.title} - </span>
            )}
            <span>
              {offerDetails.description}.
              {(() => {
                const expiryDate =
                  offerDetails.couponExpiryDate ||
                  offerDetails.couponexpirydate;
                return expiryDate && expiryDate.trim() !== ""
                  ? ` Expires ${expiryDate}.`
                  : "";
              })()}
            </span>
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default OfferDetailsFooter;
